module.exports = __webpack_public_path__ + "static/media/amazon_banner.cc129a04.jpg";